const worksTemplate = {
  id: null,
  startDate: null,
  startDateStr: null,
  endDate: null,
  endDateStr: null,
  company: null,
  position: null,
  jobLevel: null,
  leaveReason: null,
  witnessName: null,
  witnessPosition: null,
  witnessPhone: null,
  hasCompetitionAgreement: 0,
  hasLaborRelation: 0,
  isOutofwork: 0,
  recentWork: false,
  witnessNameV: 'null/null',
};

const outOfWorksTemplate = {
  reason: '',
};

export { worksTemplate, outOfWorksTemplate };
